import { validate as validateEmail } from "email-validator";
import { z } from "zod";

import {
  Button,
  TextControlGroup,
} from "shared/components";
import { createHookForm } from "shared/lib/hook-form";

const schema = z.object({
  email: z.string().min(1).refine((value) => validateEmail(value), {
    message: "Invalid email",
  }),
  password: z.string().min(1),
});

export type SignInData = z.infer<typeof schema>;

export const SignInForm = createHookForm<SignInData>(({
  formState: { isSubmitting },
}) => {
  return (
    <div className="flex flex-col gap-4">
      <TextControlGroup name="email" label="メールアドレス" placeholder="taro@soctoc.jp" required />
      <TextControlGroup name="password" type="password" label="パスワード" required />
      <Button type="submit" block primary large disabled={isSubmitting}>
        ログインする
      </Button>
    </div>
  );
}, {
  schema,
});
